;
ko.extenders.async = function (computedDeferred, options)
{

    console.log('is used')
    const plainObservable = ko.observable(options.initialValue);
     
    let promise;
    const computed = ko.computed(function () {
         
        //const count = plainObservable.getSubscriptionsCount();
        //console.log('COUNT: '+ count)
        promise?.cancel?.();

        promise = computedDeferred();

        promise
            .then(options.then)
            .then(res => plainObservable(res))
            .catch((err) => { 
                plainObservable({ $error: err })
            });
    });
    ////at some point:
    //computed.dispose()  
    plainObservable.dispose = function () {
        computed.dispose()
    }


    return plainObservable;
};
